import { Injectable } from '@angular/core';
import { AppStorage, InstallerConfig } from './models/entities';
import { Observable } from 'rxjs';
import { async } from 'rxjs/internal/scheduler/async';



@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  appStorage: AppStorage = new AppStorage();

  constructor() {
    this.refreshAppStorage();
  }

  // Get Local User Object from Local Storage
  getAppStorage(): AppStorage {
    return this.appStorage;

  }

  getKey(): Promise<string>{
    return this.appStorage.auth;
  }

  getTenantDomains(): Promise<string>{
    return this.appStorage.extratenants;
  }

  // Set Local User Object using the given value.
  async setAppStorage(appS: AppStorage) : Promise<boolean> {
   
    localStorage.setItem('kaioteeappsettings', JSON.stringify(appS));
    this.refreshAppStorage();

    return true;
  }


  initAppInstaller() {
    let instConfig = new InstallerConfig();
    instConfig.appinit = true;
    localStorage.setItem('kaioteeappinstaller', JSON.stringify(instConfig));
  }

  isAppInstallerShown(): Boolean {
    let instConfig: InstallerConfig = JSON.parse(localStorage.getItem('kaioteeappinstaller') || null);
    if (instConfig == null || instConfig == undefined) {
      return false;
    } else {
      return (instConfig.appinit);
    }

  }

  async refreshAppStorage() {
    try {
      this.appStorage = JSON.parse(localStorage.getItem('kaioteeappsettings') || null);
    } catch (e) {
      throw new Error("PhoneNotRegistered");
    }
  }

  // Destroy the Local User Object.
  destroy() {
    localStorage.removeItem('kaioteeappsettings');
    localStorage.removeItem('kaioteeappinstaller');
  }


}
